window.Instant = window.Instant || {};
window.Instant.initializedVersion = window.Instant?.initializedVersion || null;
window.Instant.initializedListeners = !!window.Instant?.initializedListeners;
window.Instant.initializedSwiper = !!window.Instant?.initializedSwiper;
window.Instant.initSwiper =
  window.Instant?.initSwiper ||
  (() => {
    window.Instant.initializedSwiper ||
      ((window.Instant.initializedSwiper = !0),
      window.Instant.initializedListeners && window.__instantInitSliders?.());
  });
(() => {
  let ct = new RegExp("^i[a-zA-Z0-9]{16}$"),
    Z = (n) => ct.test(n),
    lt = (n) => (Z(n) ? n.substring(1, 16 + 1) : n),
    v = (n) => {
      let e = Array.from(n.classList);
      return e.find((t) => Z(t)) ?? e[0];
    },
    j = (n) => n?.replace(/gid:\/\/shopify\/.*\//im, ""),
    X = (n) => {
      let e = n.parentElement;
      return e instanceof HTMLSpanElement ? X(e) : e;
    },
    U = (n) => {
      let e = n.getAttribute("data-instant-repeater-index");
      return `${lt(v(n))}${e != null ? `_${e}` : ""}`;
    },
    tt = (n, e) => n?.replace(/:(-?\d+)/, `:${e}`),
    dt = ({
      dataset: n,
      variantId: e,
      scope: t,
      scopeId: i,
      priceElements: r,
      comparativePriceElements: a,
      variantSelectOptions: c,
      variantRadios: o,
      featuredVariantImages: d,
      repeaterImages: g,
      addToCartButtons: m,
      viewProductButtons: E,
      quantity: h,
      customVariantSelects: P,
      sellingPlanElements: b,
      selectedSellingPlan: y,
      conditionals: I,
    }) => {
      if (!e) {
        for (let p of r)
          p?.closest("[data-instant-form-product-url]") === t &&
            p &&
            (p.innerHTML = "&nbsp;");
        for (let p of a)
          p?.closest("[data-instant-form-product-url]") === t &&
            p &&
            (p.innerHTML = "&nbsp;");
        for (let p of m)
          p.closest("[data-instant-form-product-url]") === t &&
            p &&
            p.setAttribute("data-instant-disabled", "true");
        for (let p of c)
          if (p?.closest("[data-instant-form-product-url]") === t && p) {
            let M = p
                ?.closest('fieldset[data-instant-type="VARIANT_PICKER"]')
                ?.querySelector(
                  'span[data-instant-type="selected-variant-option"]'
                ),
              $ = p.closest("select");
            p.value === $?.value
              ? (p.setAttribute("selected", ""),
                M && (M.innerHTML = p.innerHTML))
              : p.removeAttribute("selected");
          }
        return;
      }
      if (
        t.closest('[data-instant-layout="PRODUCT_TEMPLATE"]') &&
        t.getAttribute("data-instant-type") === "root"
      ) {
        let p = new URL(window.location.toString());
        p.searchParams.set("variant", e),
          window.history.replaceState({}, "", p.toString());
      }
      let T = new URLSearchParams({ variant: e, section_id: n.sectionId });
      y?.sellingPlanId && T.set("selling_plan", y.sellingPlanId),
        fetch(`${n.url}?${T.toString()}`)
          .then((p) => p.text())
          .then((p) => {
            let M = new DOMParser().parseFromString(p, "text/html"),
              $ = t.getAttribute("data-instant-form-product-url"),
              [D, R] = i.split("_"),
              A = M.querySelector(
                `.i${D}${
                  R != null ? `[data-instant-repeater-index="${R}"]` : ""
                }[data-instant-form-product-url="${$}"]`
              );
            if (!A) {
              console.warn("Could not find source element in response");
              return;
            }
            let x = Array.from(
                A?.querySelectorAll(
                  '[data-instant-dynamic-content-source="PRICE"]'
                )
              ),
              L = ["COMPARE_AT", "SAVED_AMOUNT", "SAVED_PERCENTAGE"]
                .map((s) => `[data-instant-dynamic-content-source="${s}"]`)
                .join(", "),
              H = Array.from(A.querySelectorAll(L)),
              _ = Array.from(
                A?.querySelectorAll(
                  'fieldset[data-instant-type="VARIANT_PICKER"] input[type="radio"]'
                )
              ),
              C = Array.from(
                A?.querySelectorAll(
                  'fieldset[data-instant-type="VARIANT_PICKER"] select option'
                )
              ),
              O = Array.from(
                A?.querySelectorAll(
                  '[data-instant-action-type="select-variant-option"]'
                )
              ),
              V = ["add-to-cart", "redirect-to-cart", "redirect-to-checkout"]
                .map((s) => `[data-instant-action-type="${s}"]`)
                .join(", "),
              Q = Array.from(A?.querySelectorAll(V)),
              B = Array.from(
                A?.querySelectorAll('[data-instant-action-type="open-page"]')
              ),
              J = Array.from(
                A?.querySelectorAll(
                  'img[data-instant-dynamic-content-source="FEATURED_IMAGE"]'
                )
              ),
              K = Array.from(
                A?.querySelectorAll(
                  'img[data-instant-dynamic-content-source="REPEATER"]'
                )
              ),
              Y = Array.from(A?.querySelectorAll("[data-instant-conditional]")),
              z = document.querySelector(`input[name="${i}__selling-plan-id"]`),
              W = document.querySelector(
                `input[name="${i}__selling-plan-name"]`
              ),
              F = !1;
            for (let s of b) {
              let u = v(s),
                l = Array.from(
                  A?.querySelectorAll(
                    '[data-instant-action-type="select-selling-plan"]'
                  )
                ).find((q) => v(q) === u);
              if (l?.closest("[data-instant-form-product-url]") !== A) continue;
              let f = decodeURIComponent(
                  l.getAttribute("data-instant-selling-plan-name")
                ),
                w = l.getAttribute("data-instant-selling-plan-id");
              if (!y && w === "one-time-purchase") {
                s.setAttribute("data-instant-state", "active");
                continue;
              }
              if (y?.sellingPlanId === w || y?.sellingPlanName === f) {
                s.setAttribute("data-instant-state", "active"),
                  l.getAttribute("data-instant-disabled") === "true" &&
                    (F = !0);
                continue;
              }
              s.setAttribute("data-instant-state", "inactive");
            }
            for (let s of r) {
              let u = v(s),
                l = x.find((f) => v(f) === u);
              l?.closest("[data-instant-form-product-url]") === A &&
                l &&
                (F ? (s.innerHTML = "&nbsp;") : (s.innerHTML = l.innerHTML));
            }
            for (let s of a) {
              let u = v(s),
                l = H.find((f) => v(f) === u);
              if (l?.closest("[data-instant-form-product-url]") === A && l) {
                F ? (s.innerHTML = "&nbsp;") : (s.innerHTML = l.innerHTML);
                let f = l.getAttribute("style");
                f ? s.setAttribute("style", f) : s.removeAttribute("style");
              }
            }
            for (let s of o) {
              let u = _.find((l) => l.id === s.id);
              if (u?.closest("[data-instant-form-product-url]") === A && u) {
                let l = u.getAttribute("data-instant-disabled");
                l
                  ? s.setAttribute("data-instant-disabled", l)
                  : s.removeAttribute("data-instant-disabled"),
                  u.hasAttribute("checked")
                    ? (s.checked = !0)
                    : (s.checked = !1);
                let f;
                if ((s.labels && ([f] = Array.from(s.labels)), f)) {
                  let w;
                  if ((u.labels && ([w] = Array.from(u.labels)), w)) {
                    let q = w.getAttribute("title");
                    q && f.setAttribute("title", q);
                  }
                }
              }
            }
            for (let s of c) {
              let u = C.find((l) => l.id === s.id);
              if (u?.closest("[data-instant-form-product-url]") === A && u) {
                let l = u.getAttribute("data-instant-disabled");
                l
                  ? s.setAttribute("data-instant-disabled", l)
                  : s.removeAttribute("data-instant-disabled"),
                  (s.textContent = u.textContent);
                let f = s
                  ?.closest('fieldset[data-instant-type="VARIANT_PICKER"]')
                  ?.querySelector(
                    'span[data-instant-type="selected-variant-option"]'
                  );
                u.hasAttribute("selected")
                  ? (s.setAttribute("selected", ""),
                    f && (f.innerHTML = u.innerHTML))
                  : s.removeAttribute("selected");
              }
            }
            for (let s of d) {
              let u = v(s),
                l = J.find((f) => v(f) === u);
              l?.closest("[data-instant-form-product-url]") === A &&
                l &&
                ((s.src = l.src),
                (s.sizes = l.sizes),
                (s.srcset = l.srcset),
                (s.alt = l.alt),
                (s.height = l.height),
                (s.width = l.width));
            }
            for (let s of g) {
              let u = K.find(
                (l) =>
                  l.getAttribute("data-instant-repeater-id") ===
                    s.getAttribute("data-instant-repeater-id") &&
                  l.getAttribute("data-instant-repeater-index") ===
                    s.getAttribute("data-instant-repeater-index")
              );
              if (u?.closest("[data-instant-form-product-url]") === A && u) {
                (s.src = u.src),
                  (s.sizes = u.sizes),
                  (s.srcset = u.srcset),
                  (s.alt = u.alt),
                  (s.height = u.height),
                  (s.width = u.width);
                let l = s.closest(".instant-slider");
                l &&
                  l.swiper?.realIndex !== 0 &&
                  l.closest("[data-instant-form-product-url]") === t &&
                  l.swiper.slideTo(0, 0);
              }
            }
            for (let s of m) {
              let u = v(s),
                l = Q.find((f) => v(f) === u);
              if (l?.closest("[data-instant-form-product-url]") === A && l) {
                l.getAttribute("data-instant-disabled") === "true"
                  ? s.setAttribute("data-instant-disabled", "true")
                  : s.removeAttribute("data-instant-disabled");
                for (let w of b)
                  w.getAttribute("data-instant-state") === "active" &&
                    w.getAttribute("data-instant-disabled") === "true" &&
                    s.setAttribute("data-instant-disabled", "true");
                s.setAttribute("data-instant-action-variant-id", e),
                  (s.href = tt(l.href, String(h ?? 1)));
              }
            }
            for (let s of E) {
              let u = v(s),
                l = B.find((f) => v(f) === u);
              if (l?.closest("[data-instant-form-product-url]") === A && l) {
                let f = new URL(l.href);
                f.searchParams.set("variant", e), (s.href = f.toString());
              }
            }
            for (let s of P) {
              let u = v(s),
                l = O.find((f) => v(f) === u);
              l?.closest("[data-instant-form-product-url]") === A &&
                l &&
                (s.setAttribute(
                  "data-instant-state",
                  l.getAttribute("data-instant-state") ?? "inactive"
                ),
                s.setAttribute(
                  "data-instant-disabled",
                  l.getAttribute("data-instant-disabled") ?? ""
                ));
            }
            y ||
              (W && W.remove(),
              z && z.value !== "one-time-purchase" && z.remove());
            for (let s of I) {
              let u = v(s),
                l = Y.find((w) => v(w) === u);
              if (l?.closest("[data-instant-form-product-url]") !== A) continue;
              let f = l.getAttribute("style");
              f ? s.setAttribute("style", f) : s.removeAttribute("style");
            }
          });
    };
  window.__instantInitSliders = (n = document) => {
    if (!window.Instant.initializedSwiper) {
      if (n.querySelector('[data-instant-type="slider"]')) {
        let a = document.createElement("script");
        (a.onload = window.Instant.initSwiper),
          (a.src =
            window.Instant.swiperScriptUrl ||
            "https://client.instant.so/scripts/swiper-bundle.min.js"),
          document.body.appendChild(a);
      }
      return;
    }
    let e = {},
      t = (a, c = "slider") => {
        if (a && a.id) {
          let o = document.getElementById(`instant-slider-${a.id}-params`),
            d = a.closest(".__instant")?.getAttribute("data-section-id"),
            g = a.getAttribute("data-instant-slider-id");
          try {
            if (o?.innerHTML) {
              let m = JSON.parse(o.innerHTML);
              if (
                (d &&
                  m.navigation &&
                  ((m.navigation.nextEl = `[data-section-id='${d}'] ${m.navigation.nextEl}`),
                  (m.navigation.prevEl = `[data-section-id='${d}'] ${m.navigation.prevEl}`)),
                m.pagination)
              ) {
                let E = document.querySelector(
                    `[data-section-id='${d}'] ${m.pagination.el}`
                  ),
                  h = E?.querySelector(".instant-slider-pagination-bullet");
                if (E && h) {
                  let P = v(h);
                  m.pagination.renderBullet = (b, y) =>
                    `<span class="${y} ${P}"></span>`;
                }
              }
              if (c === "thumbnails") {
                let E = new Swiper(a, m);
                e[`${g}`] = E;
              } else
                m.thumbs &&
                  e?.[`${g}`] &&
                  (m.thumbs = { swiper: e?.[`${g}`], ...m.thumbs }),
                  new Swiper(a, m);
            }
          } catch {}
        }
      },
      i = n.querySelectorAll('[data-instant-type="thumbnails"]');
    Array.from(i).forEach((a) => {
      t(a, "thumbnails");
    });
    let r = n.querySelectorAll('[data-instant-type="slider"]');
    Array.from(r).forEach((a) => {
      t(a);
    });
  };
  let ut = (n) => {
      let e = document.getElementById(`i${n}`);
      e && e.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    et = (n, e = !1) => {
      n.forEach((t) => {
        let i = t.querySelector(
          ':scope > [data-instant-type="accordion-content"]'
        );
        if (i) {
          let r = i.style.transitionDuration;
          (i.style.transitionDuration = "0s"),
            i.style.setProperty(
              "--instant-accordion-content-height",
              "initial"
            ),
            i.style.setProperty("--instant-accordion-content-width", "initial");
          let { height: a, width: c } = i.getBoundingClientRect();
          (i.style.transitionDuration = r),
            i.style.setProperty("--instant-accordion-content-height", "0"),
            i.style.setProperty("--instant-accordion-content-width", "0");
          let o = () => {
            a &&
              i.style.setProperty(
                "--instant-accordion-content-height",
                `${a}px`
              ),
              c &&
                i.style.setProperty(
                  "--instant-accordion-content-width",
                  `${c}px`
                );
          };
          e
            ? o()
            : "requestAnimationFrame" in window
            ? window.requestAnimationFrame(o)
            : setTimeout(o, 16);
        }
      });
    },
    pt = (n) => {
      let e = n.querySelectorAll('[data-instant-type="accordion-container"]');
      Array.from(e)
        .reverse()
        .forEach((t) => {
          let i = t.getAttribute("data-is-multi-open-enabled") === "true",
            r = t.querySelectorAll(
              ':scope > [data-instant-type="accordion-item"]'
            );
          et(Array.from(r), !0),
            Array.from(r).forEach((a) => {
              let c = a.querySelector(
                ':scope > [data-instant-type="accordion-header"]'
              );
              c &&
                c.addEventListener("click", () => {
                  let o = a.getAttribute("data-state") === "open";
                  a.setAttribute("data-state", o ? "closed" : "open"),
                    o || et([a]),
                    i ||
                      Array.from(r).forEach((d) => {
                        d !== a &&
                          d.getAttribute("data-state") === "open" &&
                          d.setAttribute("data-state", "closed");
                      });
                });
            });
        });
    },
    mt = (n) => {
      let e = n.querySelectorAll('[data-instant-type="countdown"]');
      Array.from(e).forEach((t) => {
        let i = t.getAttribute("data-instant-countdown-date"),
          r = t.getAttribute("data-instant-countdown-time-zone"),
          a = t.getAttribute("data-instant-countdown-minutes"),
          c = t.getAttribute("data-instant-countdown-is-persistent") === "true",
          o = t.getAttribute("data-instant-countdown-leading-zeros") === "true",
          d = !!i,
          g = ["DAYS", "HOURS", "MINUTES", "SECONDS"],
          [m, E, h, P] = g.map((S) =>
            t.querySelectorAll(
              `[data-instant-dynamic-content-source="COUNTDOWN_${S}"] span`
            )
          ),
          b = (S) => {
            let L = new Date(),
              H = L.getTime(),
              _ = (d ? -L.getTimezoneOffset() : 0) * 60 * 1e3;
            return S - H + _;
          },
          y = (S) => {
            let L = S.toString();
            return o ? L.padStart(2, "0") : L;
          },
          I,
          T = `instant-countdown-end-${t.id}`,
          p = sessionStorage.getItem(T);
        if (d) I = i ? new Date(i).getTime() : new Date().getTime();
        else if (p && c) I = Number(p);
        else {
          let S = new Date().getTime() + (a ? Number(a) : 0) * 60 * 1e3;
          c &&
            !window?.Shopify?.designMode &&
            sessionStorage.setItem(T, `${S}`),
            (I = S);
        }
        let $ = (() => {
            let S = new Date();
            S.setSeconds(0, 0);
            let L = S.toLocaleString("en-US", {
                timeZone: r ?? "Etc/UTC",
                hourCycle: "h23",
              }),
              H = /(\d+)\/(\d+)\/(\d+), (\d+):(\d+)/.exec(L);
            if (H) {
              let [_, C, O, N, V, Q] = H.map(Number),
                B = Date.UTC(N, C - 1, O, V, Q);
              return Math.floor((B - S.getTime()) / (1e3 * 60));
            }
            return 0;
          })(),
          D = (d ? $ : 0) * 60 * 1e3,
          R = I - D,
          A = 0,
          x = (S) => {
            let L = Math.ceil(b(R) / 1e3),
              H = 0,
              _ = 0,
              C = 0,
              O = 0;
            S - A >= 1e3 &&
              (L > 0 &&
                ((O = Math.floor(L / (24 * 60 * 60))),
                (C = Math.floor((L / (60 * 60)) % 24)),
                (_ = Math.floor((L / 60) % 60)),
                (H = Math.floor(L % 60))),
              m.length === 0 && O > 0 && (C = C + O * 24),
              E.length === 0 && C > 0 && (_ = _ + C * 60),
              h.length === 0 && _ > 0 && (H = H + _ * 60),
              Array.from(m).forEach((N) => {
                N.innerHTML = `${y(O)}`;
              }),
              Array.from(E).forEach((N) => {
                N.innerHTML = `${y(C)}`;
              }),
              Array.from(h).forEach((N) => {
                N.innerHTML = `${y(_)}`;
              }),
              Array.from(P).forEach((N) => {
                N.innerHTML = `${y(H)}`;
              }),
              (A = S)),
              L >= 0 && requestAnimationFrame(x);
          };
        requestAnimationFrame(x);
      });
    },
    ft = (n) => {
      let e = n.querySelectorAll("[data-instant-product-recommendations]");
      Array.from(e).forEach((t) => {
        let i = t?.parentElement,
          r = t.getAttribute("data-instant-product-recommendations");
        if (i && r) {
          if (t.getAttribute("data-instant-observed")) return;
          t.setAttribute("data-instant-observed", "true");
          let a = (o, d) => {
            if (!o[0].isIntersecting) return;
            d.unobserve(i);
            let g = t.getAttribute("data-url");
            g &&
              fetch(g)
                .then((m) => m.text())
                .then((m) => {
                  let h = new DOMParser()
                    .parseFromString(m, "text/html")
                    .querySelector(
                      `[data-instant-product-recommendations-output="${r}"]`
                    );
                  h &&
                    h.innerHTML.trim().length &&
                    (t.insertAdjacentHTML("afterend", h.innerHTML),
                    i && G(i),
                    t.remove());
                })
                .catch((m) => {
                  console.error(m);
                });
          };
          new IntersectionObserver(a, {
            rootMargin: "0px 0px 200px 0px",
          }).observe(i);
        }
      });
    },
    gt = (n, e) => {
      let i = ((c) => {
        if (!c) return null;
        let o = c.closest("[data-instant-form-product-url]");
        if (!o) return null;
        let d = o.querySelector(
          '[data-instant-dynamic-content-source="QUANTITY_SELECT"]'
        );
        if (d) return d;
      })(n);
      if (!i) return;
      let r = parseInt(i?.value, 10);
      isNaN(r) && (r = 1);
      let a = e === "increment" ? r + 1 : r - 1;
      a < 1 ||
        a > 999 ||
        ((i.value = a.toString()),
        i.dispatchEvent(new Event("change", { bubbles: !0 })));
    },
    yt = (n) => {
      let e = n.closest("[data-instant-form-product-url]");
      if (!e) return null;
      let t = U(e),
        i = `${t}__${n.getAttribute("data-instant-option-name")}`,
        r = n.getAttribute("data-instant-option-value") ?? "",
        a = e.querySelectorAll(`input[name^="${t}__"]`),
        c = [];
      for (let o of a) o.name === i && c.push(o);
      if (c?.length === 1) c[0].value = r;
      else if (c?.length > 1)
        c.forEach((o) => {
          o.checked = o.value === n.getAttribute("data-instant-option-value");
        });
      else {
        let o = document.createElement("input");
        e.appendChild(o),
          o.setAttribute("type", "hidden"),
          o.setAttribute("name", i),
          o.setAttribute("value", r);
      }
      e.dispatchEvent(new Event("change", { cancelable: !0, bubbles: !0 }));
    },
    At = (n) => {
      let e = n.closest("[data-instant-form-product-url]");
      if (!e) return null;
      let t = U(e),
        i = (r, a) => {
          let c = n.getAttribute(a) ?? "",
            o = e.querySelector(`input[name="${r}"]`);
          if (o) o.value = c;
          else {
            let d = document.createElement("input");
            e.appendChild(d),
              d.setAttribute("type", "hidden"),
              d.setAttribute("name", r),
              d.setAttribute("value", c);
          }
        };
      i(`${t}__selling-plan-id`, "data-instant-selling-plan-id"),
        i(`${t}__selling-plan-name`, "data-instant-selling-plan-name"),
        e.dispatchEvent(new Event("change", { cancelable: !0, bubbles: !0 }));
    },
    nt = async (n) => {
      let e = n.getAttribute("data-instant-action-type"),
        t = n.getAttribute("data-instant-action-id"),
        i = n.getAttribute("data-instant-action-variant-id");
      if (
        n.getAttribute("data-instant-disabled") === "true" &&
        !["select-variant-option", "select-selling-plan"].includes(e)
      )
        return !0;
      switch (e) {
        case "add-to-cart":
        case "redirect-to-cart":
        case "redirect-to-checkout":
          let a = new URL(n.href).pathname.split(":").pop() ?? "1",
            c = n.getAttribute("data-instant-discount-code"),
            o = n.getAttribute("data-instant-clear-cart") === "true",
            d = n.closest("[data-instant-form-product-url]");
          if (!d) return null;
          let g = U(d),
            m = d.querySelector(`input[name="${g}__selling-plan-id"]`),
            E = d.querySelector(`input[name="${g}__selling-plan-name"]`),
            h = d.getAttribute("data-instant-form-selling-plan-id"),
            { sellingPlans: P } = rt(d, g);
          if (m?.value || E?.value)
            if (m?.value === "one-time-purchase") h = null;
            else {
              let b = P.find(
                (y) =>
                  (y.sellingPlanId === m?.value ||
                    y.sellingPlanName === decodeURIComponent(E?.value ?? "")) &&
                  y.variantId === i
              );
              b?.sellingPlanId && (h = b.sellingPlanId);
            }
          n.classList.add("instant-loading"),
            (n.style.cursor = "wait"),
            n.setAttribute("disabled", "disabled"),
            o &&
              (await fetch(`${window.Shopify?.routes?.root}cart/clear.js`, {
                method: "POST",
              }).catch((b) => {
                console.error("Failed to clear cart", b);
              })),
            c &&
              ((document.cookie = `discount_code=${c}; path=/`),
              await fetch(`${window.Shopify?.routes?.root}discount/${c}`).catch(
                (b) => {
                  console.error("Failed to set discount code", b);
                }
              )),
            fetch(`${window.Shopify?.routes?.root}cart/add.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                items: [
                  {
                    id: i,
                    quantity: a,
                    ...(h !== "one-time-purchase" ? { selling_plan: h } : {}),
                  },
                ],
              }),
            })
              .then((b) => {
                if (!b.ok) throw new Error();
                switch (e) {
                  case "redirect-to-cart":
                    window.location.href = `${window.Shopify?.routes?.root}cart`;
                    break;
                  case "redirect-to-checkout":
                    window.location.href = `${window.Shopify?.routes?.root}checkout`;
                    break;
                  default:
                    let y = new CustomEvent("instant:add-to-cart", {
                      bubbles: !1,
                    });
                    document.dispatchEvent(y);
                }
              })
              .catch(() => {
                let b = document.createElement("form");
                b.setAttribute("method", "POST"),
                  b.setAttribute(
                    "action",
                    `${window.Shopify?.routes?.root}cart/add`
                  ),
                  b.setAttribute("novalidate", "novalidate"),
                  [
                    ["id", i ?? ""],
                    ["product-id", t ?? ""],
                    ["form_type", "product"],
                    ["quantity", a],
                    ["utf8", "\u2713"],
                  ].forEach(([y, I]) => {
                    let T = document.createElement("input");
                    T.setAttribute("type", "hidden"),
                      T.setAttribute("name", y),
                      T.setAttribute("value", I),
                      b.appendChild(T);
                  }),
                  document.body.appendChild(b),
                  b.submit();
              })
              .finally(() => {
                n.classList.remove("instant-loading"),
                  n.style.removeProperty("cursor"),
                  n.removeAttribute("disabled");
              });
          break;
        case "scroll-to-section":
          t && ut(t);
          break;
        case "quantity-increment":
        case "quantity-decrement":
          gt(n, e === "quantity-increment" ? "increment" : "decrement");
          break;
        case "select-variant-option":
          yt(n);
          break;
        case "select-selling-plan":
          At(n);
          break;
        case "open-page":
          return !1;
        default:
          return console.warn(`Unknown instant action type: ${e}`), !1;
      }
      return !0;
    },
    bt = (n) => {
      let e = n.querySelectorAll(
        'a[data-instant-action-type]:not([data-instant-action-type="open-page"]), button[data-instant-action-type], div[data-instant-action-type]'
      );
      Array.from(e).forEach((i) => {
        i.addEventListener("click", (r) => {
          r.preventDefault(), r.stopPropagation();
          let a = r.currentTarget;
          return !a || !(a instanceof HTMLElement) ? null : (nt(a), !1);
        });
      });
      let t = document.querySelectorAll(
        ".__instant div[href], .__instant form[href]"
      );
      Array.from(t).forEach((i) => {
        i.addEventListener("click", (r) => {
          let a = r.currentTarget;
          if (!a || !(a instanceof HTMLElement)) return null;
          let c = X(r.target);
          r.target instanceof HTMLLabelElement ||
            r.target instanceof HTMLInputElement ||
            r.target instanceof HTMLFieldSetElement ||
            r.target instanceof HTMLAnchorElement ||
            r.target instanceof HTMLButtonElement ||
            c instanceof HTMLAnchorElement ||
            c instanceof HTMLButtonElement ||
            c instanceof HTMLInputElement ||
            c instanceof HTMLLabelElement ||
            c instanceof HTMLFieldSetElement ||
            (r.preventDefault(),
            r.stopPropagation(),
            nt(a).then((o) => {
              if (o) return;
              let d = a.getAttribute("href"),
                g = a.getAttribute("target"),
                m = a.getAttribute("rel");
              d && window.open(d, g || "_self", m || void 0);
            }));
        });
      });
    },
    it = (n, e) => {
      let t = n.split("/").pop();
      e.setAttribute("name", `__tt_embed__${t}`),
        window.addEventListener("message", (i) => {
          try {
            let r = JSON.parse(i.data);
            r.height &&
              document
                .querySelector(`[name="${r.signalSource}"]`)
                ?.closest(".instant-video__container, .video__container")
                ?.setAttribute(
                  "style",
                  `height:${r.height}px;width:325px;border-radius:8px 8px 8px 8px;overflow:hidden`
                );
          } catch {}
        });
    },
    ht = (n) => {
      let e = n.querySelectorAll(
        "article.instant-video__wrapper, article.video__wrapper"
      );
      Array.from(e).forEach((t) => {
        t.addEventListener("click", () => {
          if (
            !t.querySelector("iframe") &&
            t.getAttribute("data-type") !== "external"
          ) {
            let i = t.getAttribute("data-src") ?? "",
              r = t.getAttribute("data-title") ?? "",
              a = document.createElement("iframe");
            (a.className = "instant-video__iframe"),
              a.setAttribute("src", i),
              a.setAttribute("title", r),
              a.setAttribute("frameborder", "0"),
              a.setAttribute(
                "allow",
                "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              ),
              a.setAttribute("allowfullscreen", "allowfullscreen"),
              t.style.setProperty("background-image", "none"),
              i?.includes("tiktok") && it(i, a),
              t.appendChild(a);
          } else if (
            !t.querySelector("video") &&
            t.getAttribute("data-type") === "external"
          ) {
            let i = t.getAttribute("data-src") ?? "",
              r = document.createElement("video");
            (r.className = "instant-video__player"),
              r.setAttribute("autoplay", "true"),
              r.setAttribute("controls", "true"),
              r.setAttribute("playsInline", "true"),
              r.setAttribute("src", i),
              t.style.setProperty("background-image", "none"),
              t.appendChild(r);
          }
        });
      });
    },
    at = (n, e) => {
      let t = document.querySelector(`.i${n}`),
        i = document.querySelectorAll(`[data-instant-tab-id="${n}"]`);
      if (e) for (let r of e) r.setAttribute("data-instant-state", "closed");
      if ((t && t.setAttribute("data-instant-state", "open"), i))
        for (let r of i) {
          let c = r?.parentNode?.querySelectorAll(
            `:scope > [data-instant-type="tabs-trigger"]:not([data-instant-tab-id="${n}"])`
          );
          if (c)
            for (let o of c) o.setAttribute("data-instant-state", "inactive");
          r.setAttribute("data-instant-state", "active");
        }
    },
    st = (n, e) => {
      let t = document.querySelector(`.i${n}`);
      if (e) for (let i of e) i.style.setProperty("display", "none");
      t && t.style.removeProperty("display");
    },
    k = "instant-scroll-trigger--hidden";
  function Et(n, e, t) {
    n.forEach((i) => {
      let r = i.target;
      i.isIntersecting
        ? (r.classList.contains(k) && r.classList.remove(k),
          t || e.unobserve(r))
        : t && r.classList.add(k);
    });
  }
  let Tt = (n) => {
      let e = n.querySelectorAll(".instant-scroll-trigger");
      e.length !== 0 &&
        e.forEach((t) => {
          let i =
              t.getAttribute("data-instant-scroll-into-view-replay") === "true",
            r = t.getAttribute("data-instant-scroll-into-view-offset")
              ? Number(t.getAttribute("data-instant-scroll-into-view-offset"))
              : 0;
          if (window.getComputedStyle(t).position === "fixed") {
            let c = !1,
              o = () => {
                if (window.scrollY < r) {
                  i && t.classList.add(k), (c = !1);
                  return;
                }
                t.classList.contains(k) && t.classList.remove(k), (c = !1);
              },
              d = () => {
                c || (window.requestAnimationFrame(o), (c = !0));
              };
            window.addEventListener("scroll", d);
          } else
            new IntersectionObserver((o, d) => Et(o, d, i), {
              root: document,
              threshold: 0,
              rootMargin: `${-r}px 0px`,
            }).observe(t);
        });
    },
    vt = (n) => {
      let e = n.querySelectorAll('[data-instant-type="tabs-container"]'),
        t = n?.querySelectorAll('[data-instant-type="tabs-trigger"]');
      Array.from(e).forEach((i) => {
        let c = i
          ?.querySelector('[data-instant-type="tabs-pane"]')
          ?.parentNode?.querySelectorAll(
            ':scope > [data-instant-type="tabs-pane"]'
          );
        c?.[0]?.id &&
          (st(c[0].id, c), window.requestAnimationFrame(() => at(c[0].id, c)));
      }),
        Array.from(t).forEach((i) => {
          let r = i.getAttribute("data-instant-tabs-id"),
            a = i.getAttribute("data-instant-tab-id");
          if (r && a) {
            let g = document
              .querySelector(`.i${r}`)
              ?.querySelector('[data-instant-type="tabs-pane"]')
              ?.parentNode?.querySelectorAll(
                ':scope > [data-instant-type="tabs-pane"]'
              );
            t &&
              g &&
              i.addEventListener("click", () => {
                let m = i.getAttribute("data-instant-tab-id") || "";
                st(m, g), window.requestAnimationFrame(() => at(m, g));
              });
          }
        });
    },
    St = (n) => {
      let e = n.querySelectorAll('[data-instant-type="ticker"]');
      Array.from(e)
        .reverse()
        .forEach((t) => {
          let i = t.querySelector(".instant-ticker-initial-child-container"),
            r = i?.closest(".instant-ticker"),
            a = r?.nextElementSibling,
            c = [r, a],
            o = t.getAttribute("data-instant-ticker-is-reversed") === "true",
            d = +(t.getAttribute("data-instant-ticker-speed") || 50),
            g = t.getAttribute("data-instant-ticker-pause") === "true" || !1;
          if (t && i) {
            let m = i.children,
              E = 1,
              h = 0,
              P = () => {
                let y = t.getBoundingClientRect(),
                  I = i.getBoundingClientRect();
                if (y && I) {
                  let T = Math.min(y.width, 9999),
                    p = I.width,
                    M = window.getComputedStyle(i),
                    $ = M.columnGap.includes("px") ? M.columnGap : "0px";
                  t.style.setProperty("--gap", $),
                    (E = p && T && p < T ? Math.ceil(T / p) : 1),
                    (h = (p * E) / d);
                }
                t.style.getPropertyValue("--multiplier") !== `${E}` &&
                  (r && r.replaceChildren(i),
                  a && (a.innerHTML = ""),
                  Array.from(c).forEach((T, p) => {
                    T &&
                      [...Array(Math.max(0, p === 0 ? E - 1 : E))].forEach(
                        () => {
                          Array.from(m).forEach((M) => {
                            let $ = M.cloneNode(!0);
                            T.appendChild($);
                          });
                        }
                      );
                  })),
                  t.style.setProperty("--play", "running"),
                  t.style.setProperty("--direction", o ? "reverse" : "normal"),
                  t.style.setProperty("--duration", `${h}s`),
                  t.style.setProperty(
                    "--pause-on-hover",
                    g ? "paused" : "running"
                  ),
                  t.style.setProperty("--multiplier", `${E}`),
                  /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
                    t.querySelectorAll('img[loading="lazy"]').forEach((p) => {
                      p.loading = "eager";
                    });
              };
            P();
            let b = new ResizeObserver(P);
            b.observe(t), b.observe(i);
          }
        });
    },
    Lt = (n) => {
      let e = n.querySelectorAll("iframe.tiktok__autoplay");
      Array.from(e).forEach((t) => {
        let i = t.getAttribute("src") ?? "";
        it(i, t);
      });
    },
    wt = (n) => {
      let e = n.querySelectorAll(
        ".instant-video-fill__controls, .video-fill__controls"
      );
      Array.from(e).forEach((t) => {
        let i = t.closest(".instant-video-fill__wrapper, .video-fill__wrapper"),
          r = i?.querySelector("video");
        i &&
          r &&
          t.addEventListener("click", () => {
            r.paused
              ? (r.play(), i.setAttribute("data-paused", "false"))
              : (r.pause(), i.setAttribute("data-paused", "true"));
          });
      });
    },
    rt = (n, e) => {
      let t = n.querySelectorAll('[type="application/json"]'),
        i,
        r,
        a;
      return (
        Array.from(t).forEach((c) => {
          c.id.startsWith(`variants__${e}--`) && (i = JSON.parse(c.innerHTML)),
            c.id.startsWith(`options__${e}--`) && (r = JSON.parse(c.innerHTML)),
            c.id.startsWith(`selling_plans__${e}--`) &&
              (a = JSON.parse(c.innerHTML));
        }),
        { variants: i, options: r, sellingPlans: a }
      );
    },
    It = (n, e) => (e ? n?.find((t) => t.id === Number(j(e))) : n?.[0]),
    Mt = (n) => {
      let e = n.querySelectorAll(
        ".__instant form[data-instant-form-product-url]"
      );
      Array.from(e).forEach((t) => {
        let i = t.closest(".__instant")?.getAttribute("data-section-id"),
          r = t.querySelectorAll(
            'input[data-instant-dynamic-content-source="QUANTITY_SELECT"]'
          );
        Array.from(r).forEach((a) => {
          a.addEventListener("blur", (c) => {
            let o = a.getAttribute("min") ?? "1",
              d = a.getAttribute("max") ?? "999",
              g = parseInt(a.value, 10);
            c.target instanceof HTMLInputElement &&
              (g = parseInt(c.target.value, 10)),
              o && g < parseInt(o, 10) && (a.value = o),
              d && g > parseInt(d, 10) && (a.value = d),
              isNaN(g) && (a.value = o),
              a.dispatchEvent(new Event("change", { bubbles: !0 }));
          });
        }),
          t.addEventListener("change", (a) => {
            let c = new FormData(a?.currentTarget),
              o = a.target?.closest("[data-instant-form-product-url]");
            if (!o) {
              console.warn("No scope found for form change event");
              return;
            }
            let d = U(o);
            if (a.target?.name === "quantity") {
              let s = parseInt(a.target?.value, 10);
              isNaN(s) && (s = 1);
              let u = o.querySelectorAll(
                'input[data-instant-dynamic-content-source="QUANTITY_SELECT"]'
              );
              for (let q of u) q.value = s.toString();
              let f = [
                  "add-to-cart",
                  "redirect-to-cart",
                  "redirect-to-checkout",
                ]
                  .map((q) => `[data-instant-action-type="${q}"]`)
                  .join(", "),
                w = o.querySelectorAll(f);
              for (let q of w) q.href = tt(q.href, s.toString());
              return;
            }
            let g = o?.getAttribute("data-instant-form-variant-id"),
              m = o?.getAttribute("data-instant-form-product-url"),
              E = o?.getAttribute("data-instant-form-selling-plan-id"),
              { variants: h, options: P, sellingPlans: b } = rt(o, d),
              y = It(h, g),
              I = [];
            for (let [s, u] of c)
              s.startsWith(d) &&
                I.push({
                  key: decodeURIComponent(s.replace(`${d}__`, "")),
                  value: String(u),
                });
            let T = [y?.option1, y?.option2, y?.option3],
              p = [];
            if (P)
              for (let s of P)
                p.push(
                  I.find(({ key: u }) => u === s.name)?.value ??
                    T[s.position - 1]
                );
            let M = h
                ? h?.find(({ option1: s, option2: u, option3: l }) => {
                    let f = [s, u, l].filter(Boolean),
                      w = p.filter(Boolean);
                    return f.every((q, Ht) => q === w[Ht]);
                  })?.id
                : g,
              $ = document.querySelector(`input[name="${d}__selling-plan-id"]`),
              D = document.querySelector(
                `input[name="${d}__selling-plan-name"]`
              ),
              R = j($?.value),
              A = j(D?.value),
              x = b?.find(
                (s) =>
                  s.variantId === M.toString() &&
                  (s.sellingPlanId === R?.toString() ||
                    s.sellingPlanName ===
                      decodeURIComponent(A?.toString() ?? ""))
              );
            !x &&
              R !== "one-time-purchase" &&
              (x = b?.find(
                (s) => s.variantId === M.toString() && s.sellingPlanId === E
              ));
            let S = o.querySelectorAll(
                '[data-instant-dynamic-content-source="PRICE"]'
              ),
              H = ["COMPARE_AT", "SAVED_AMOUNT", "SAVED_PERCENTAGE"]
                .map((s) => `[data-instant-dynamic-content-source="${s}"]`)
                .join(", "),
              _ = o.querySelectorAll(H),
              C = o.querySelectorAll(
                'fieldset[data-instant-type="VARIANT_PICKER"] select option'
              ),
              O = o.querySelectorAll(
                'fieldset[data-instant-type="VARIANT_PICKER"] input[type="radio"]'
              ),
              N = o.querySelectorAll(
                'img[data-instant-dynamic-content-source="FEATURED_IMAGE"]'
              ),
              V = o.querySelectorAll(
                'img[data-instant-dynamic-content-source="REPEATER"]'
              ),
              B = ["add-to-cart", "redirect-to-cart", "redirect-to-checkout"]
                .map((s) => `[data-instant-action-type="${s}"]`)
                .join(", "),
              J = o.querySelectorAll(B),
              K = '[data-instant-action-type="open-page"]',
              Y = o.querySelectorAll(K),
              z = o.querySelectorAll(
                '[data-instant-action-type="select-variant-option"]'
              ),
              W = o.querySelectorAll(
                '[data-instant-action-type="select-selling-plan"]'
              ),
              F = o.querySelectorAll("[data-instant-conditional]");
            dt({
              dataset: { url: m, sectionId: i },
              variantId: M,
              scope: o,
              scopeId: d,
              priceElements: S,
              comparativePriceElements: _,
              variantSelectOptions: C,
              variantRadios: O,
              featuredVariantImages: N,
              repeaterImages: V,
              addToCartButtons: J,
              viewProductButtons: Y,
              quantity: c.get("quantity") ?? 1,
              customVariantSelects: z,
              sellingPlanElements: W,
              selectedSellingPlan: x,
              conditionals: F,
            });
          });
      }),
        Array.from(e).forEach((t) => {
          t.dispatchEvent(new Event("change"));
        });
    },
    G = (n) => {
      window.Instant.initializedListeners = !0;
      let e = document;
      if (n)
        if (n instanceof Element) e = n;
        else {
          let t = document.getElementById(n);
          t && (e = t);
        }
      pt(e),
        mt(e),
        bt(e),
        ft(e),
        ht(e),
        Tt(e),
        vt(e),
        St(e),
        Lt(e),
        window.__instantInitSliders?.(e),
        wt(e),
        Mt(e);
    },
    // Pt = () => {
    //   window.Shopify?.shop &&
    //     document.querySelector(".__instant") &&
    //     fetch(
    //       `https://static-api.instant.so/public/site/${window.Shopify.shop}`
    //     )
    //       .then((n) => n.json())
    //       .then((n) => {
    //         if (n?.showBadge) {
    //           let e = () =>
    //               new DOMParser().parseFromString(n.showBadge, "text/html").body
    //                 .firstChild,
    //             t = document.body.appendChild(e()),
    //             i = new MutationObserver((r) => {
    //               r.forEach((a) => {
    //                 if (
    //                   (a.type === "childList" &&
    //                     [...a.removedNodes].includes(t)) ||
    //                   a.type === "attributes"
    //                 ) {
    //                   i.disconnect(), t && t.parentNode && t.remove();
    //                   let c = e();
    //                   (t = document.body.appendChild(c)),
    //                     i.observe(t, { attributes: !0 }),
    //                     i.observe(document.body, { childList: !0 });
    //                 }
    //               });
    //             });
    //           i.observe(t, { attributes: !0 }),
    //             i.observe(document.body, { childList: !0 });
    //         }
    //       });
    // },
    ot = () => {
      G(),
        Pt(),
        window?.Shopify?.designMode &&
          document.addEventListener("shopify:section:load", (n) => {
            let e = `shopify-section-${n.detail.sectionId}`;
            e && G(e);
          });
    };
  document.readyState !== "loading"
    ? ot()
    : document.addEventListener("DOMContentLoaded", () => {
        ot();
      });
})();
